import { render, staticRenderFns } from "./vehicle_basicinfo.vue?vue&type=template&id=499cdd66&scoped=true"
var script = {}
import style0 from "./vehicle_basicinfo.vue?vue&type=style&index=0&id=499cdd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cdd66",
  null
  
)

export default component.exports